// The label Learn shows above the prompt, in the service line of the
// definition-layout card (multiple choice without a usable sentence, and
// fill-in-the-blank that falls back to this layout: no example, or an
// irregular form the blank cannot be built from).

import type { AppTranslations } from '../i18n/app'
import type { LearningNextCard, SideInfo } from '../types'
import { sideKindLabel } from './cardSideDisplay'

type PromptSide = Pick<SideInfo, 'label'> & { kind?: string | null }

/** "From memory" for the definition formats; otherwise the prompt field's
 * name in the interface language. A built-in kind is named by the editor's
 * translated label (`sideKindLabel`, the one kind-to-name rule); a custom
 * field keeps the exact name its author gave it. The stored label is never
 * shown as-is for a built-in kind: it is the English cosmetic label, which is
 * what put "DEFINITION" beside "ПО ПАМЯТИ" in the Russian interface. */
export function learnPromptLabel(
  format: LearningNextCard['exercise_format'] | string | undefined,
  prompt: PromptSide,
  tr: AppTranslations,
): string {
  if (format === 'definition_strict' || format === 'definition_only') return tr.learn.fromMemory
  return sideKindLabel(prompt, tr.cardEditor)
}
